'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateAttachmentFile = undefined;

var _attachmentErrors = require('../../file-uploads/constants/attachmentErrors');

var _fileExceedsSizeLimit = require('./fileExceedsSizeLimit');

var _fileExtensionIsBlacklisted = require('./fileExtensionIsBlacklisted');

var _defer = require('q/js/lib/defer');

var _defer2 = _interopRequireDefault(_defer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validateAttachmentFile = exports.validateAttachmentFile = function validateAttachmentFile(file) {
  var validationDeferred = (0, _defer2.default)();

  if ((0, _fileExceedsSizeLimit.fileExceedsSizeLimit)(file)) {
    validationDeferred.reject(_attachmentErrors.SIZE_LIMIT_EXCEEDED);
  }
  if ((0, _fileExtensionIsBlacklisted.fileExtensionIsBlacklisted)(file)) {
    validationDeferred.reject(_attachmentErrors.BLACKLISTED_EXTENSION);
  } else {
    validationDeferred.resolve();
  }

  return validationDeferred.promise;
};


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/util/validateAttachmentFile.js
// module id = 555
// module chunks = 2 3